// extracted by mini-css-extract-plugin
export default {"container":"BankAccount_container__DRnbd","inputs":"BankAccount_inputs__7Yssq","formInput":"BankAccount_formInput__fo6or"};